/* SPLENDIDO — avviso ferie (Urlaubspause) · 2026-08-09
   -------------------------------------------------------------------------
   Scrive la data del rientro dentro gli avvisi resi da `sp-urlaub-hinweis.liquid`
   e li mostra SOLO se la data e' valida e ancora futura.

   Perche' la data la mette il JavaScript e non Liquid: il filtro `date` di
   Shopify non traduce i nomi dei mesi (nei locale non c'e' `date_formats`),
   quindi in inglese o in polacco sarebbe uscito il mese in tedesco.

   Il testo invece NON e' qui: sta nelle chiavi locale, cosi' T-Lab puo'
   correggerlo senza toccare il codice. Qui arriva col segnaposto __SP_DATUM__.

   Il carrello viene ridisegnato da Prestige a ogni `cart:refresh`
   (replaceChildren) → riapplichiamo su `cart-drawer:refreshed`, altrimenti
   nel cassetto resterebbe il segnaposto al posto della data. */
(function () {
  'use strict';
  if (window.__spUrlaubInit) return;   /* le sezioni rieseguono i loro script a ogni ridisegno */
  window.__spUrlaubInit = true;

  var MESI = {
    de: ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
    en: ['January','February','March','April','May','June','July','August','September','October','November','December'],
    fr: ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'],
    es: ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'],
    nl: ['januari','februari','maart','april','mei','juni','juli','augustus','september','oktober','november','december'],
    pl: ['stycznia','lutego','marca','kwietnia','maja','czerwca','lipca','sierpnia','września','października','listopada','grudnia']
  };

  function lingua() {
    var l = (document.documentElement.lang || 'de').substring(0, 2).toLowerCase();
    return MESI[l] ? l : 'de';
  }

  /* Stesse regole della scheda prodotto: „25. August" · „25 August" ·
     „1er septembre" · „25 de agosto" · „25 augustus" · „25 sierpnia". */
  function scriviData(dt, lang) {
    var g = dt.getDate(), m = MESI[lang][dt.getMonth()];
    if (lang === 'de') return g + '. ' + m;
    if (lang === 'es') return g + ' de ' + m;
    if (lang === 'fr') return (g === 1 ? '1er' : g) + ' ' + m;
    return g + ' ' + m;
  }

  function dataValida(valore) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(String(valore || '').trim())) return null;
    var d = new Date(valore.trim() + 'T00:00:00');
    if (isNaN(d.getTime())) return null;
    var oggi = new Date();
    oggi.setHours(0, 0, 0, 0);
    return d > oggi ? d : null;   /* data passata = ferie finite: non mostrare nulla */
  }

  function applica(radice) {
    var lang = lingua();
    var nodi = (radice || document).querySelectorAll('[data-sp-urlaub]');
    for (var i = 0; i < nodi.length; i++) {
      var el = nodi[i];
      var d = dataValida(el.getAttribute('data-sp-urlaub-ab'));
      if (!d) { el.hidden = true; continue; }
      if (el.textContent.indexOf('__SP_DATUM__') !== -1) {
        el.textContent = el.textContent.replace('__SP_DATUM__', scriviData(d, lang));
      }
      el.hidden = false;
    }
  }

  function avvia() {
    applica(document);
    document.addEventListener('cart-drawer:refreshed', function () { applica(document); });
    document.addEventListener('cart:refresh', function () { setTimeout(function () { applica(document); }, 60); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }
})();
